import { Delete, KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { Card, CardContent, CardHeader, Chip, Collapse, IconButton, Stack } from '@mui/material'
import React, { useState } from 'react'
import GenricMultiSelect from '../Input/GenericMultiSelect';
import { listOfMappingsType, singleEventProps } from '../../features/manageEvents/ManageEventsType';
import { optionsList } from '../../features/manageEvents/ManageEventConfig';
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider';

function SingleEvent(props: singleEventProps) {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Manage Events"
    const { event, updateMappingStateInsideEvents } = props
    const [open, setOpen] = useState<boolean>(false);

    const getOptions = () => {
        if (optionsList.hasOwnProperty(event.id)) return [...optionsList[event.id]]
        else return []
    }

    const handleKeysSelect = (type: listOfMappingsType, selectedKeys: Array<string>) => {
        const newMapping = {
            ...event?.mappings,
            [type]: {
                ...event.mappings[type],
                params: [...selectedKeys]
            }
        }
        updateMappingStateInsideEvents(event.id, newMapping)
    }

    const getSelectedOptions = (type: listOfMappingsType) => {
        return event?.mappings[type]?.params;

    }

    const handleChipDelete = (type: listOfMappingsType, value: string) => {
        const newChips = (event?.mappings[type]?.params)?.filter((chip: string) => (chip !== value))
        const newMapping = {
            ...event?.mappings,
            [type]: {
                ...event?.mappings[type],
                params: [...newChips]
            }
        }
        updateMappingStateInsideEvents(event.id, newMapping)
    }


    const handleDeleteEvent = (id: string) => {
        props.handleDeleteEvent(id)
    }


    return (
        <>
            <Card className='single-event-card'>
                <CardHeader
                    title={event?.id ?? ''}
                    className={`${open ? 'single-event-card-header-underline' : ''}`}
                    action={
                        <Stack direction={"row"}>
                            <IconButton size='small' className='delete-event-btn' onClick={() => handleDeleteEvent(event.id)}>
                                <Delete />
                            </IconButton>
                            <IconButton size="small" className="validateCollapseToggleBtn" onClick={() => setOpen(!open)}>
                                {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>

                        </Stack>
                    }
                />
                {
                    open &&
                    <CardContent className='single-event-card-content'>
                        <Collapse in={open} timeout="auto" unmountOnExit className='single-event-collapse'>
                            <Stack direction={"column"} spacing={2} >
                                <Stack direction={"column"} spacing={1}>
                                    <GenricMultiSelect
                                        className='eventType-multiSelect'
                                        label='Firebase'
                                        options={getOptions()}
                                        selectedOptions={getSelectedOptions('firebase')}
                                        handleMultiSelectState={(selectedKeys: string[]) => {
                                            handleKeysSelect('firebase', selectedKeys)
                                        }}
                                        isRequired={false}
                                    />
                                    <div className='firebase-selected-keys'>
                                        {
                                            event?.mappings['firebase']?.params?.map((value: string) => <Chip className='event_chip' label={value} key={value} onDelete={(e: React.MouseEvent) => handleChipDelete("firebase", value)} />)
                                        }
                                    </div>
                                </Stack>
                                <Stack direction={"column"} spacing={1}>
                                    <GenricMultiSelect
                                        label={translate(TranslationEnum.manage_events,"Moengage")}
                                        className='eventType-multiSelect'
                                        options={getOptions()}
                                        selectedOptions={getSelectedOptions('moengage')}
                                        handleMultiSelectState={(selectedKeys: string[]) => {
                                            handleKeysSelect('moengage', selectedKeys)
                                        }}
                                        isRequired={false}
                                    />
                                    <div className='moengage-selected-keys'>
                                        {
                                            event?.mappings['moengage']?.params?.map((value: string) => <Chip className='event_chip' label={value} key={value} onDelete={(e: React.MouseEvent) => handleChipDelete("moengage", value)} />)
                                        }
                                    </div>
                                </Stack>
                                <Stack direction={"column"} spacing={1}>
                                    <GenricMultiSelect
                                        label={translate(TranslationEnum.manage_events,"Database")}
                                        className='eventType-multiSelect'
                                        options={getOptions()}
                                        selectedOptions={getSelectedOptions('database')}
                                        handleMultiSelectState={(selectedKeys: string[]) => {
                                            handleKeysSelect('database', selectedKeys)
                                        }}
                                        isRequired={false}
                                        limitTags={100}
                                    />
                                    <div className='database-selected-keys'>
                                        {
                                            event?.mappings['database']?.params.map((value: string) => <Chip className='event_chip' label={value} key={value} onDelete={(e: React.MouseEvent) => handleChipDelete("database", value)} />)
                                        }
                                    </div>
                                </Stack>
                            </Stack>
                        </Collapse>
                    </CardContent>
                }
            </Card>

        </>

    )
}

export default SingleEvent